// export const firebaseConfig = {
//   apiKey: "AIzaSyDZ8JcB7FtwWxqKT9irbqXk2pS7bs2D_fc",
//   authDomain: "fcode-k16.firebaseapp.com",
//   databaseURL: "https://fcode-k16.firebaseio.com",
//   projectId: "fcode-k16",
//   storageBucket: "fcode-k16.appspot.com",
//   messagingSenderId: "761414295095",
//   appId: "1:761414295095:web:facb599f53aa8286fc69b2",
// };
export const firebaseConfig = {
  apiKey: "AIzaSyCVB6_nnd_FBv8j-7C3jipveXYAu7kHD1A",
  authDomain: "fcode-fpthcm-k15-application.firebaseapp.com",
  databaseURL: "https://fcode-fpthcm-k15-application.firebaseio.com",
  projectId: "fcode-fpthcm-k15-application",
  storageBucket: "",
  messagingSenderId: "1068494998594",
  appId: "1:1068494998594:web:47b04b04b462aa2bc0f1db"
};
